<template lang="html">
	<div id="app" class="main column no-header">
		<div class="background-login"></div>
		<div class="active anonymous login">
			<img src="~@/common/assets/img/logo-patrim.svg" alt="">
			<div class="heading">
				Accédez anonymement à Patrimoffice et testez nous sans engagement.
			</div>

<!--			<form class="form-ui column" novalidate>-->
<!--				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('username')}">-->
<!--					<label for="email">Votre pseudo</label>-->
<!--					<input v-validate="'required'" type="text" name="username" v-model="username">-->
<!--				</div>-->
<!--				<div v-if="errors.has('username')" class="error-message">{{ errors.first('username') }}</div>-->
<!--				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('password')}">-->
<!--					<label for="password">Mot de passe</label>-->
<!--					<input v-validate="'required'" type="password" name="password" v-model="password">-->
<!--				</div>-->
<!--				<div v-if="errors.has('password')" class="error-message">{{ errors.first('password') }}</div>-->
<!--			</form>-->
			<div class="ctn-connect">
				<div class="light btn btn-black" @click="subscribe">
					Accès rapide à Patrimoffice
				</div>
			</div>
<!--			<router-link class="ctn-password-reset link" :to="{name: 'AnonymousLogin'}">-->
<!--				Connexion anonyme-->
<!--			</router-link>-->
			<router-link class="ctn-password-reset link" :to="{name: 'Subscribe'}">
				Inscription
			</router-link>
		</div>
	</div>
</template>

<script>
import AnonymousResource from '@/resources/Anonymous'
import LocalStorage from '@/common/services/local-storage'
import {ANONYMOUS_USER_LOGIN_KEY} from '@/utils/constants'

export default {
	name: 'AnonymousSubscribe',
	data () {
		return {
			username: null,
			password: null,
			retryMax: 100
		}
	},
	created () {
		this.autoLoginAnonymousUser()
	},
	methods: {
		subscribe () {
			this.retryMax -= 1
			this.generateUniqAnonymousUsername()

			// eslint-disable-next-line no-unreachable
			AnonymousResource.register(this.username, this.password).then(() => {
				this.saveAnonymousLogin()
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Inscription',
					text: 'Votre compte anonyme a été créé avec succès'
				})
				this.loginAnonymousUser()
				// this.$router.push({ name: 'AnonymousLogin' })
			}).catch((error) => {
				if (this.retryMax > 0) {
					this.subscribe()
				} else {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Inscription',
						text: error.message
					})
				}
			})
		},
		loginAnonymousUser () {
			this.$store.commit('LOADER_IN')
			this.$store.dispatch('anonymousLogin', {
				email: this.username,
				password: this.password
			}).then(() => {
				this.$store.commit('LOADER_OUT')
				this.$router.push({ name: 'Main' })
			}).catch((error) => {
				this.$store.commit('LOADER_OUT')
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Connexion',
					text: error.message
				})
			})
		},
		saveAnonymousLogin () {
			LocalStorage.setItem(ANONYMOUS_USER_LOGIN_KEY, JSON.stringify({ username: this.username }))
		},
		generateUniqAnonymousUsername () {
			const uniqId = new Date().getUTCMilliseconds()

			this.username = 'ano' + uniqId + '@anonymous.ano'
			this.password = this.username
		},
		autoLoginAnonymousUser () {
			const loginRawData = LocalStorage.getItem(ANONYMOUS_USER_LOGIN_KEY)

			if (!loginRawData) {
				return
			}

			const login = JSON.parse(loginRawData)
			this.username = login.username
			this.password = login.username

			this.loginAnonymousUser()
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Auth/AnonymousSubscribe.vue